"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exchangeRefreshToken;

var _lodash = _interopRequireDefault(require("lodash.get"));

var _cookie = require("@rentspree/cookie");

var _debug = _interopRequireDefault(require("./debug"));

var _const = require("./const");

var _axiosConfig = require("./axios-config");

var _axiosUserInstance = require("./axios-user-instance");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @module AxiosRefreshToken
 */
var debug = (0, _debug.default)("rentspree-axios-refresh-token:refresh-token");
var authTokenRequest;
/**
 * This method is used to clear the pending request singleton
 * It mostly will be used for the testing purpose.
 * @memberof AxiosRefreshToken
 * @private
 */

function resetAuthTokenRequest() {
  debug("resetAuthTokenRequest");
  authTokenRequest = null;
}
/**
 * This method retrieve the refresh token request
 * It will return the pending request promise (Singleton)
 * Just in case 2 simultaneous API call refresh token at the same time
 * With this singleton pattern, the return will be the Promise of the pending request.
 * So both requesting API would eventually receive the same Refresh Token.
 * @param {String} baseUserApi the base API for auth service
 * @returns {Promise<Object>} the axios request promise
 * @memberof AxiosRefreshToken
 * @example
 * import { AxiosRefreshToken } from "@rentspree/axios-refresh-token"
 * AxiosRefreshToken.exchangeRefreshToken("api.example.com")
 *   .then((res) => {
 *     //..
 *   })
 */


function exchangeRefreshToken(baseUserApi) {
  debug("exchangeRefreshToken was called with baseUserApi:%s", baseUserApi);

  if (!authTokenRequest) {
    var token = (0, _cookie.getLocalItem)(_const.STORAGE.USER_TOKEN);
    var accessToken = (0, _lodash.default)(token, "access_token");
    var refreshToken = (0, _lodash.default)(token, "refresh_token");
    debug("return new fire /token with refreshToken:%s", refreshToken);
    authTokenRequest = (0, _axiosUserInstance.getAxiosUserInstance)(baseUserApi).post("/api/v2/token", {
      refresh_token: refreshToken,
      grant_type: "refresh_token"
    }, (0, _axiosConfig.axiosConfig)(accessToken)); // TODO:- why this have to be 2 ??

    authTokenRequest.then(resetAuthTokenRequest, resetAuthTokenRequest);
  }

  debug("return previous promise refresh token fire %o", authTokenRequest);
  return authTokenRequest;
}